import * as React from 'react';

import styled from 'styled-components';

const Wrapper = styled.div<{ background: string }>`
  border: dashed 1px #333;
  padding: 20px;
  background: ${(props) => props.background};
`;

const colorMap: Record<string, string> = {
  // greenish
  test: 'rgb(134 255 166 / 10%);',
  // blueish
  fallback: 'rgb(134 138 255 / 10%)',
  // yellowish
  other: 'rgb(255 246 134 / 10%)',
};

const versionToBgColor = (version: string) => {
  const matchedColors = Object.keys(colorMap)
    .filter((versionKey) => {
      return version.includes(versionKey);
    })
    .map((versionKey) => colorMap[versionKey]);

  if (matchedColors.length > 0) {
    return matchedColors[0];
  }

  return 'rgb(255 134 134 / 10%)'; // redish
};

export const Version = (): JSX.Element => {
  const version = process.env.APP_VERSION || 'unknown';
  const background = versionToBgColor(version);

  return (
    <Wrapper background={background}>
      <b>App version: </b>
      <span>{version}</span>
    </Wrapper>
  );
};
